<template>
  <el-dialog
      title="批量添加设备"
      :append-to-body="true"
     :before-close="closeMulti"
     class="addMultiDeviceView"
      :close-on-click-modal="false"
      :visible.sync="multiVisible"
      width="25%">
      <!-- <span slot="title" class="dialog-footer">
        <span>批量添加设备</span>
      </span> -->
      <el-form ref="ruleForm"  :rules="rules" :model="form">
        <el-row>
        <span class="star">*</span>
        产品
      </el-row>
       <el-row>
         <el-form-item label="" prop="addMultiProductKey">
            <el-select @change="selMultiChange" v-model="form.addMultiProductKey" placeholder="请选择" size="small">
              <el-option
                v-for="item in productList"
                :key="item.productKey"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
         </el-form-item>
      </el-row>
      <el-form-item label="创建方式" :required="true">
        <el-radio-group v-model="radio">
          <el-radio :label="0">手动添加</el-radio>
          <el-radio :label="1">Excel导入</el-radio>
        </el-radio-group>
      </el-form-item>
       <el-row v-if="radio===0">
         <span  class="star">*</span>
        设备数量
        <el-tooltip :content="deviceNumTips" placement="right" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </el-row>

      <el-form-item label="" prop="deviceNum" v-if="radio===0">
        <el-input  v-model="form.deviceNum" placeholder="请输入设备数量" type="number" size="small"></el-input>
      </el-form-item>
      <el-form-item label="选择文件" prop="url" v-else>
          <el-upload
            ref="upload"
            name="file"
            action="bb"
            :auto-upload="false"
            :on-change="handleChange"
            accept=".xls,.xlsx"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <span class="model" @click="downLoadModel">点击下载模板格式</span>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="addMultiDevice" size="small">确 定</el-button>
        <el-button @click="closeMulti" size="small">取 消</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { addDevice, addStatus, importFile } from '@/api/deviceManagement'
import { eventBus } from '@/utils/eventBus'
import { v4 as uuidv4 } from 'uuid'
import { loadFileByUrl } from '@/utils'
export default {
  props: {
    multiParams: {
      type: Object
    },
    multiVisible: {
      type: Boolean
    },
    productList: {
      type: Array
    }
  },
  data () {
    var validateDeviceNum = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('设备数量必须大于0'))
      } if (value > 1000) {
        callback(new Error('设备数量不能大于1000'))
      } else {
        callback()
      }
    }
    const fileNumber = (rule, value, callback) => {
      if (this.radio !== 0 && this.$refs.upload.uploadFiles.length === 0) {
        callback(new Error('请选择文件！'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        addMultiProductKey: [
          { required: true, message: '请选择产品', trigger: 'change' }
        ],
        deviceNum: [
          { required: true, message: '请输入设备数量', trigger: 'change' },
          { validator: validateDeviceNum, trigger: 'change' }
        ],
        url: [
          { required: true, validator: fileNumber, trigger: 'change' }
        ]
      },
      form: {
        addMultiProductKey: '',
        deviceNum: ''
      },
      radio: 0,
      fileList: [],
      deviceNumTips: '单次最多添加1000台，系统会自动生成全局唯一的DeviceName'
    }
  },
  watch: {
    multiVisible () {
      console.log('变化了')
      if (this.multiVisible) {
        this.$nextTick(() => {
          this.multiParams.deviceNum = ''
          this.$refs.ruleForm.resetFields()
          this.fileList.splice(0, this.fileList.length)
        })
      }
      this.radio = 0
    },
    radio: { // 解决v-if判断下from表单错误提示一直存在问题
      handler (val) {
        if (val === 0) {
          this.$refs.ruleForm.clearValidate('url')
        } else {
          this.$refs.ruleForm.clearValidate('deviceNum')
        }
      }
    }
  },
  methods: {
    downLoadModel () {
      // window.open('http://xliot-dev.oss-cn-shenzhen.aliyuncs.com/previewFile/20201231/eba4fc32a1d64ee7b665727d6296e1a5.xlsx?Expires=4765103999&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=J%2FrgCUQxPZXyUikJryxq4i7Pxlw%3D')
      loadFileByUrl('https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/previewFile/20201231/eba4fc32a1d64ee7b665727d6296e1a5.xlsx?Expires=4765103999&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=J%2FrgCUQxPZXyUikJryxq4i7Pxlw%3D')
    },
    selMultiChange () {
      this.multiParams.showProductErrMes = false
    },
    closeMulti () {
      this.$emit('closeMulti')
    },
    addMultiDevice () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.radio === 0) {
            const params = {
              addType: 1, // 0:表示添加单个设备，1：表示添加多个设备
              deviceNum: this.form.deviceNum ? parseInt(this.form.deviceNum) : '',
              productKey: this.form.addMultiProductKey
            }
            console.log('添加多个设备发送参数：', params)
            addDevice(params).then(res => {
              res = res.data
              console.log('添加多个设备返回：', res)
              const queryStateParams = res.data
              if (res.code === 200) {
                // 添加多个设备的弹窗处理
                this.$emit('closeMulti') // 隐藏弹窗
                this.$emit('openMultiSuccessView') // 显示成功提示的弹框
                this.interval = setInterval(() => {
                  this.getAddStatus(queryStateParams)
                }, 1000)
              // this.getAddStatus(queryStateParams)
              } else {
                this.$message.error('设备添加失败')
              }
            })
          } else {
            this.fileRequest(this.fileList[0])
          }
        }
      })
    },
    getAddStatus (params) {
      console.log('查询状态参数：', params)
      const that = this
      const code = this.$httpCode
      const getState = function () {
        addStatus(params).then(res => {
          res = res.data
          console.log('查询添加返回状态：', res)
          Object.prototype.toString.call(res.data) === '[object Object]' && res.data.code === code.CREATED
            ? (
              // 进入这里表示添加成功
              console.log('是对象'),
              that.multiParams.deviceNum = res.data.successNum,
              that.multiParams.errorNum = res.data.errorNum,
              that.multiParams.url = res.data.url,
              that.$emit('getDeviceList'), // 重新获取设备列表
              eventBus.$emit('get-multi-device-list'),
              clearInterval(that.interval)// 清除定时
            )
            : ''
        })
      }
      getState()
    },
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.fileList = fileList
    },
    fileRequest (file) {
      // 添加多个设备的弹窗处理
      this.$emit('closeMulti') // 隐藏弹窗
      this.$emit('openMultiSuccessView') // 显示加载提示的弹框
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('productKey', this.form.addMultiProductKey)
      formData.append('id', uuidv4())
      formData.append('timestamp', Date.parse(new Date()))
      formData.append('version', '1.0')
      importFile(formData)
        .then(res => {
          res = res.data
          console.log('导入返回：', res)
          const queryStateParams = res.data
          if (res.code === 200) {
            // 添加多个设备的弹窗处理
            this.$emit('closeMulti') // 隐藏弹窗
            this.$emit('openMultiSuccessView') // 显示成功提示的弹框
            this.interval = setInterval(() => {
              this.getAddStatus(queryStateParams)
            }, 1000)
            // this.getAddStatus(queryStateParams)
          } else {
            this.$message.error('设备添加失败')
            // this.$message.error(res.data.message)
            // const that = this
            // setTimeout(function () {
            //   that.$emit('closeView')// 关闭加载提示弹窗
            // }, 1000)
          }
        }, res => {
          this.$emit('closeView')// 关闭加载提示弹窗
        })
    }

  }
}
</script>
<style lang="less" scope>
  .addMultiDeviceView{
    .star{
       color:#d93026;
    }
    .errMes{
      color:#d93026;
      margin-top: 10px;
    }
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .el-row:nth-child(even){
      margin-top: 5px;
    }
    .el-row:nth-child(odd){
      margin-top: 15px;
    }
    .el-select{
      width: 100%;
    }
    .model{
       vertical-align:bottom;
       margin-left: 10px;
       color: #409EFF;
       line-height: 24px;
    }
  }
</style>
